import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import Report from "../../containers/Report";

const Components = ({match}) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/view`}/>
    <Route path={`${match.url}/view`} component={Report}/>
  </Switch>
);

export default Components;